import moment from 'moment';

export default class DecisioningHelper {
  // The decision TABLE data is READ ONLY so it does not matter if we change the structure
  static parseDecisionTableData(data) {
    return (Array.isArray(data) ? data : []).map((row) => {
      const address = row?.primaryApplicant?.addresses?.find(({ type }) => type === 'installation');
      return Object.assign({}, row, {
        owner: `${row?.owner?.firstName || ''} ${row?.owner?.lastName || ''}`,
        applicantName: `${row?.primaryApplicant?.lastName || ''}, ${row?.primaryApplicant?.firstName || ''}`,
        cityAndState: `${address?.city || ''}, ${address?.stateAbbr || ''}`,
        expirationDate: row.expirationDate ? moment(row.expirationDate).diff(moment(), 'days') : '',
      });
    });
  }

  // the decision PAGE is going to be sent back to Java so we can NOT modify the structure
  static parseDecisionPageData(data) {
    const blank_data = {
      id: '',
      customerId: '',
      creditCheckId: '',
      applicationDate: '',
      owner: {
        id: '',
        userName: '',
        firstName: '',
        lastName: '',
      },
      status: '',
      products: [
        {
          id: '',
          sku: '',
          maxDTIVerified: 0,
          rateCards: [
            {
              id: '',
              decision: '',
              term: '',
              apr: '',
              deferralMonths: '',
              loanType: '',
              maxApprovedLoanAmount: '',
              maxPossiblePaymentVerified: 0,
            },
          ],
          denialReasons: [
            {
              denialCode: '',
              denialText: '',
            },
          ],
        },
      ],
      stipulations: [
        {
          type: '',
          status: '',
          decisionReason: '',
          files: [],
        },
      ],
      primaryApplicant: {
        firstName: '',
        lastName: '',
        phone: '',
        emailAddress: '',
        statedIncome: 0,
        estimatedIncome: 0,
        verifiedIncome: 0,
        bureauPerson: {
          ficoScore: 0,
          freezeType: '',
          ofacStatus: '',
          fraudAlertStatus: '',
          akaList: [
            {
              name: '',
            },
          ],
          tradelines: [
            {
              id: '',
              accountNumber: '',
              currentBalance: '',
              dateClosed: '',
              dateOpened: '',
              highCredit: '',
              includeInDTI: '',
              monthlyPayment: '',
              memberName: '',
              paymentScheduleMonthCount: '',
              portfolioType: '',
              scheduledMonthlyPayment: '',
              monthlyPaymentOverride: '',
            },
          ],
        },
        isFrozen: null,
        isOfac: null,
        isAddressMismatch: null,
        addresses: [
          {
            type: '',
            address1: '',
            city: '',
            stateAbbr: '',
            zip: '',
          },
        ],
      },
      coApplicant: {
        firstName: '',
        lastName: '',
        phone: '',
        emailAddress: '',
        statedIncome: 0,
        estimatedIncome: 0,
        verifiedIncome: 0,
        bureauPerson: {
          ficoScore: 0,
          freezeType: '',
          ofacStatus: '',
          tradelines: [
            {
              id: '',
              accountNumber: '',
              currentBalance: '',
              dateClosed: '',
              dateOpened: '',
              highCredit: '',
              includeInDTI: '',
              monthlyPayment: '',
              memberName: '',
              paymentScheduleMonthCount: '',
              portfolioType: '',
              scheduledMonthlyPayment: '',
              monthlyPaymentOverride: '',
            },
          ],
        },
        isFrozen: null,
        isOfac: null,
        isAddressMismatch: null,
        addresses: [
          {
            type: '',
            address1: '',
            city: '',
            stateAbbr: '',
            zip: '',
          },
        ],
      },
      contractorCompanyName: '',
      expirationDate: '',
      manualUWComplete: '',
      isHighFicoFail: null,
      decisionOverride: '',
      decisionNotes: '',
      totalExistingMonthlyDebt: 0,
    };

    return Object.assign(
      {
        ...blank_data,
      },
      data
    );
  }

  static parseDecisionPageUsers(data) {
    if (data === null || data === undefined || data.size === 0) {
      data = [{ id: '', userName: '', firstName: '', lastName: '' }];
    }
    return data;
  }
}
